import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { QuarterlyRevenue } from '../types';

const GOLD = '#D4AF37';
const LEATHER = '#3D2B1F';
const CHARCOAL = '#1A1A1A';

interface PartnerRevenueChartProps {
  data: QuarterlyRevenue[];
  quarterLabel?: string;
}

export default function PartnerRevenueChart({ data }: PartnerRevenueChartProps) {
  const chartData = data.map((q) => ({
    name: q.quarter,
    revenue: q.revenue,
  }));

  if (chartData.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-station-muted border border-leather rounded-lg bg-leather/20">
        No quarterly revenue data yet
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-leather bg-leather/40 p-5">
      <p className="text-station-muted text-sm mb-3">Your revenue by quarter</p>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 12, right: 12, left: 0, bottom: 24 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={LEATHER} opacity={0.6} />
            <XAxis
              dataKey="name"
              tick={{ fill: GOLD, fontSize: 12 }}
              axisLine={{ stroke: GOLD, opacity: 0.5 }}
              tickLine={{ stroke: GOLD, opacity: 0.5 }}
            />
            <YAxis
              tick={{ fill: GOLD, fontSize: 12 }}
              axisLine={{ stroke: GOLD, opacity: 0.5 }}
              tickLine={{ stroke: GOLD, opacity: 0.5 }}
              tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: CHARCOAL,
                border: `1px solid ${GOLD}`,
                borderRadius: 8,
              }}
              formatter={(value: number) => [`$${value.toLocaleString()}`, 'Revenue']}
            />
            <Bar dataKey="revenue" fill={GOLD} radius={[4, 4, 0, 0]} maxBarSize={60} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
